import { Button } from 'primereact/button';
import { Carousel } from 'primereact/carousel';
import { InputText } from 'primereact/inputtext';
import { OverlayPanel } from 'primereact/overlaypanel';
import React, { useEffect, useRef, useState } from 'react'
import Media from '../../../components/Media/Media';

import ProductService from "../../../service/ProductService";
export default function P220PicList({data}) {


    
    const carouselResponsiveOptions = [
        {
            breakpoint: "1280px",
            numVisible: 3,
            numScroll: 4,
        },
        {
            breakpoint: "1024px",
            numVisible: 2,
            numScroll: 4,
        },
        {
            breakpoint: "768px",
            numVisible: 2,
            numScroll: 2,
        },
        {
            breakpoint: "560px",
            numVisible: 1,
            numScroll: 1,
        },
    ];


    useEffect(() => {
        // console.log('data ',data);
    }, [data])

    
    const carouselItemTemplate = (data) => {
        return (
            <div className="product-item ">
                <div className="product-item-content" style={{}}>
                    <div className="p-mb-3">
                        <Media
                            path = {data.photoPath}
                            alt = {data.photoTypeDesc}
                            style={{ width: 140, height: 144}}
                            // type ={images}
                        />
                    </div>
                    <div style={{textAlign:'left', marginLeft : 10}}>
                        <label className="p-mb-1">
                            {
                                data.photoDesciption && data.photoDesciption !== '' ?
                                ( <><b>คำอธิบาย </b> {data.photoDesciption}</>):
                                (<><b>คำอธิบาย </b> </>)
                            }
                           </label>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div>
            <div className="p-grid p-fluid media-demo">
                <div className="p-col-12">
                    <div className="card">
                        
                        <div className="p-col-12" style={{paddingTop:20}}>
                            {
                                data && data.length > 0 ?(
                                    <Carousel 
                                        value={data} 
                                        numVisible={4} numScroll={4} 
                                        responsiveOptions={carouselResponsiveOptions} 
                                        itemTemplate={carouselItemTemplate}
                                    >
                                    </Carousel>
                                ):('No Data')
                            }

                        </div>

                    </div>
                </div>
                
            </div>
        </div>
    )
}
